import styled, { css } from 'styled-components';

export const Element = styled.nav`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.white};
      padding: ${theme.spacing.base};
      border-radius: ${theme.radius.sm};
      box-shadow: ${theme.box_shadow.base};
      font-size: ${theme.typography.font_size.text_sm};

      // TODO: REVIEW THIS, AND MAYBE REMOVE
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        padding: 1.5rem ${theme.spacing.md};
      }
    `;
  }};
`;

export const BreadcrumbList = styled.ol`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      gap: ${theme.spacing.sm};
    `;
  }};
`;
export const BreadcrumbItem = styled.li`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      align-items: center;

      &:not(:first-child):before {
        display: block;
        width: ${theme.spacing.base};
        height: ${theme.spacing.base};
        margin-right: ${theme.spacing.sm};
        content: '';
        background-image: url('data:image/svg+xml;utf8,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M22.7076%2016.7075L12.7076%2026.7075C12.6147%2026.8004%2012.5044%2026.8741%2012.383%2026.9244C12.2616%2026.9747%2012.1315%2027.0006%2012.0001%2027.0006C11.8687%2027.0006%2011.7386%2026.9747%2011.6172%2026.9244C11.4958%2026.8741%2011.3855%2026.8004%2011.2926%2026.7075C11.1997%2026.6146%2011.126%2026.5043%2011.0757%2026.3829C11.0254%2026.2615%2010.9995%2026.1314%2010.9995%2026C10.9995%2025.8686%2011.0254%2025.7385%2011.0757%2025.6171C11.126%2025.4957%2011.1997%2025.3854%2011.2926%2025.2925L20.5863%2016L11.2926%206.70751C11.1049%206.51987%2010.9995%206.26537%2010.9995%206.00001C10.9995%205.73464%2011.1049%205.48015%2011.2926%205.29251C11.4802%205.10487%2011.7347%204.99945%2012.0001%204.99945C12.2654%204.99945%2012.5199%205.10487%2012.7076%205.29251L22.7076%2015.2925C22.8005%2015.3854%2022.8743%2015.4957%2022.9246%2015.6171C22.975%2015.7385%2023.0009%2015.8686%2023.0009%2016C23.0009%2016.1314%2022.975%2016.2615%2022.9246%2016.3829C22.8743%2016.5043%2022.8005%2016.6146%2022.7076%2016.7075Z%22%20fill%3D%22%239B9B9B%22%2F%3E%3C%2Fsvg%3E');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 95%;
      }

      &[aria-current='page'] {
        color: ${theme.color.neutral_500};
      }
    `;
  }};
`;
